import { isHandledMediaAccessError } from './mediaAccessErrors';

interface requestMediaProps {
  setPermission: React.Dispatch<React.SetStateAction<boolean>>;
}

export const requestMedia = async (props: requestMediaProps): Promise<boolean> => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch (error) {
    if (isHandledMediaAccessError(error)) {
      props.setPermission(true);
    }
    console.error('Media access failed:', error);
    return false;
  }
};
